<template>
  <v-container fluid>
    <v-row class="mb-6">
      <v-col cols="12" align="center">
        <v-btn @click="clearAddress" dark color="blue darken-3">
          <v-icon left>mdi-arrow-left-bold-circle</v-icon>Change address
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="text-center justify-center mt-4 mb-4">
      <v-col>
        <iframe
          width="500"
          height="400"
          style="border: 0"
          loading="lazy"
          allowfullscreen
          :src="`https://www.google.com/maps/embed/v1/search?key=${googleMapsApiKey}&q=${address.address},${city.name}&zoom=17`"
        ></iframe>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" align="center">
        <h4 class="text-h4 blue--text text--darken-4 text-center">
          We offer these services at
          <strong>{{ address.address }}, {{ city.name }}, IL</strong>:
        </h4>
      </v-col>
    </v-row>
    <v-container fluid>
      <v-row class="mt-4 mx-4" justify="center">
        <v-col
          v-for="(service, key) in filteredServiceOffers"
          :key="key"
          align="center"
          fill-height
        >
          <ServiceCard
            :business="business"
            :service="service"
            :serviceOffers="serviceOffers"
          />
        </v-col>
      </v-row>
    </v-container>
    <v-row class="mt-12">
      <v-col>
        <h5 class="text-h5 text-center blue--text text--darken-4 mb-6">
          <a
            :href="`https://www.htc.net/service-contact?address=${address.address}&city=${city.name}&address_type=${addressType}`"
            target="_parent"
            >Click here</a
          >
          to provide your contact info. We'll reach out to get you signed up for
          service!
        </h5>
        <h5 class="text-h5 text-center blue--text text--darken-4">
          Or call
          <strong>618.939.6112</strong> to speak to our friendly local customer
          service team. We're available
          <strong>8:00am to 4:30pm Mon. - Fri</strong>.
        </h5>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ServiceCard from "./ServiceCard.vue";
export default {
  components: { ServiceCard },
  name: "Services",

  props: ["address", "city", "business", "googleMapsApiKey"],

  mounted() {
    this.fetchServiceOffers();
  },

  data: () => ({
    serviceOffers: [],
  }),

  methods: {
    clearAddress() {
      this.$emit("clearAddress");
    },
    fetchServiceOffers() {
      this.$axios
        .get("/api/service-addresses/" + this.address.id)
        .then(({ data }) => {
          this.serviceOffers = data.serviceOffers;
        })
        .catch(() => {
          this.serviceOffers = [];
        })
        .then(() => {
          this.loading = false;
          console.log(this.maxInternetPackage);
        });
    },
  },
  computed: {
    addressType() {
      return this.business ? "Business" : "Residence";
    },
    maxInternetPackage() {
      if (this.serviceOffers && this.serviceOffers.length > 0) {
        let serviceOffers = this.serviceOffers.filter((x) => {
          return (
            ["internet", "wireless"].includes(x.service_type) &&
            x.business == this.business
          );
        });
        if (serviceOffers.length) {
          return serviceOffers.reduce((prev, current) =>
            prev.download_mbps > current.download_mbps ? prev : current
          );
        }
        return null;
      }
      return null;
    },
    phonePackage() {
      if (this.serviceOffers && this.serviceOffers.length > 0) {
        return this.serviceOffers.find((x) => {
          return x.service_type === "phone" && x.business == this.business;
        });
      }
      return null;
    },
    tvPackage() {
      if (this.serviceOffers && this.serviceOffers.length > 0) {
        return this.serviceOffers.find((x) => {
          return x.service_type === "tv" && x.business == this.business;
        });
      }
      return null;
    },
    filteredServiceOffers() {
      if (this.serviceOffers && this.serviceOffers.length > 0) {
        let serviceOffers = this.serviceOffers.filter((x) => {
          return (
            x.service_type !== "internet" &&
            x.service_type !== "wireless" &&
            x.service_type !== "phone" &&
            x.service_type !== "tv" &&
            x.name !== "IPTV"
          );
        });
        if (this.phonePackage) {
          serviceOffers.unshift(this.phonePackage);
        }
        if (this.maxInternetPackage) {
          serviceOffers.splice(1, 0, this.maxInternetPackage);
          serviceOffers = serviceOffers.filter((x) => {
            return x.service_type !== "viasat";
          });
        }
        if (this.tvPackage) {
          serviceOffers.splice(2, 0, this.tvPackage);
        }
        return serviceOffers;
      }
      return [];
    },
  },
};
</script>
